<template>
  <div :class="['view', 'basket', { 'no-fixed': $route.name === 'BasketMessage' }]">
    <template>
      <div
        v-if="$route.name !== 'BasketMessage' && attraction.item"
        class="basket-header"
      >
        <div class="container">
          <template v-if="attraction.item">
            <span v-if="!attraction.item.stream" class="basket-header-headline headline">{{ attraction.item.headline }}</span>
            <h1 class="basket-header-title h1">{{ attraction.item.title }}</h1>
            <span v-if="attraction.item.stream" class="basket-header-label label">{{ attraction.item.headline }}</span>
            <span
              v-if="event && event.venue"
              class="basket-header-location"
            >
              {{ event.venue.label }}
            </span>
            <span
              v-if="event && event.date"
              class="basket-header-date"
            >
              {{ event.date }}
            </span>

            <ul class="basket-header-steps">
              <li
                v-for="(step, index) in steps"
                :key="`step-${index}`"
                :class="`basket-header-step${step.route === $route.name ? ' is-current' : ''}`"
              >
                <span class="step-check">
                  <sprite
                    :type="'check'"
                    :width="18"
                    :height="14"
                  />
                </span>
                <span class="step-number">{{ index + 1 }}</span>
                <span class="step-text">{{ step.label }}</span>
              </li>
            </ul>
          </template>
        </div>
      </div>

      <div
        class="basket-content"
      >
        <div class="container">
          <router-view />
        </div>

        <loader v-if="loading"/>
      </div>
    </template>

    <!-- <loader/> -->
    <!-- <loader v-if="loading"/> -->
  </div>
</template>

<script>
import Loader from '@/components/components/Loader.vue';
import Sprite from '@/components/components/Sprite.vue';
// Data
import basket from '@/data/static/basket.json';

export default {
  components: {
    Loader,
    Sprite
  },
  async beforeMount() {
    if (this.$route.name !== 'BasketMessage') {
      const attraction = this.attraction.id || localStorage.getItem('basketAttraction');
      // eslint-disable-next-line
      const getattraction = await this.$store.dispatch('basket/getAttraction', attraction);

      const orderID = localStorage.getItem('orderID');
      if (orderID && orderID !== 'null') {
        // eslint-disable-next-line
        const getorder = await this.$store.dispatch('basket/getOrder', orderID);
      }
    }
  },
  beforeDestroy() {
    this.$store.dispatch('basket/reset');
  },
  data() {
    return {
      steps: [...basket.steps]
    };
  },
  computed: {
    date() {
      return this.$store.state.basket.date;
    },
    event() {
      return this.$store.state.basket.datas.event;
    },
    attraction() {
      return this.$store.state.basket.attraction;
    },
    step() {
      let index = 0;

      this.steps.map((step, i) => {
        if (step.route === this.$route.name) {
          index = i;
        }
      });

      return index;
    },
    loading() {
      return this.$store.state.basket.requests !== 0;
    }
  },
  methods: {
    onPrev() {
      const { route } = this.steps[this.step - 1];
      this.$router.push({ name: route });
    },
    onNext() {
      const { route } = this.steps[this.step + 1];
      this.$router.push({ name: route });
    }
  }
};
</script>

<style lang="scss" scoped>
.basket {
  padding-top: 0;

  // Header
  // -----------------------------------------------------------------------------
  &-header {
    @include padding(134px null 40px);
    background-color: $black-light;

    .container {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }

    &-title {
      @include margin(10px null null);
    }

    &-label {
      margin-top: 8px;
    }

    &-location {
      @include margin(12px null null);
      font-size: rem(18px);
      line-height: (22 / 18);
    }

    &-date {
      @include margin(12px null null);
      color: $primary;
      font-size: rem(18px);
      line-height: (22 / 18);
    }

    &-steps {
      @include margin(38px -18px null);
      display: flex;
      justify-content: space-between;
      width: calc(100% + 36px);
    }

    &-step {
      display: flex;
      position: relative;
      flex-direction: column;
      align-items: center;
      width: 25%;

      &:not(:last-child) {
        &::before {
          @include position(absolute, 25px null null 50%);
          @include size(100%, 1px);
          content: '';
          z-index: 0;
          border-top: 1px dashed $green;
        }
      }

      &.is-current {
        &::before {
          border-color: $grey-light-alternate;
        }

        .step-check {
          display: none;
        }

        .step-number {
          display: flex;
          background-color: $black;
          color: $white;
        }

        .step-text {
          color: $white;
        }

        ~ .basket-header-step {
          &::before { border-color: $grey-light-alternate; }
          .step-check { display: none; }
          .step-number { display: flex; }
        }
      }

      .step-check {
        @include size(50px);
        position: relative;
        border: 2px solid $green;
        border-radius: 50%;
        background-color: $black;

        .svg {
          @include position(absolute, 50% null null calc(50% + 2px));
          transform: translate(-50%, -50%);
          fill: $green;
        }
      }

      .step-number {
        @include font('secondary', 'medium');
        @include padding(null null null 0px);
        @include size(50px);
        display: none;
        justify-content: center;
        position: relative;
        z-index: 1;
        border-radius: 50%;
        background-color: $black;
        color: rgba($white, .4);
        font-size: rem(24px);
        line-height: 50px;
      }

      .step-text {
        @include font('primary', 'bold');
        @include margin(16px null null);
        color: rgba($white, .4);
        font-size: rem(13px);
        line-height: 1;
      }
    }
  }

  // Content
  // -----------------------------------------------------------------------------
  &-content {
    @include padding(35px null 32px);
    // min-height: calc(100vh - 104px);
  }

  .loader {
    @include position(absolute, 50% null null 50%);
    transform: translate(-50%, -50%);
  }
}
</style>

<style lang="scss">
.view.basket {
  display: flex;
  flex-direction: column;

  .basket-content {
    position: relative;
    flex-grow: 1;

    .loader {
      @include position(absolute, 50% null null 50%);
      transform: translate(-50%, -50%);
    }
  }

  .subview {
    position: relative;

    .loader {
      @include position(absolute, 50% null null 50%);
      transform: translate(-50%, -50%);
    }
  }
}

.view.basket:not(.no-fixed) {
  & + .footer {
    @include margin(null null 89px);
  }
}
</style>
